const ENDPOINT = new Map();

ENDPOINT.set('get', '/course/calendar/recording/get');

export default ENDPOINT
